import { useProject } from '@contexts/Project.context';
import { convertToRgba } from '@utils/map/helpers';
import styled from 'styled-components';

const Legend = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
	background-color: ${props => props.theme.colors.background};
	border-radius: 8px;

	padding: 20px;
	z-index: 1;
	max-width: 250px;

	h2 {
		color: ${props => props.theme.colors.textColor};
		font-size: 1rem;
		opacity: 0.7;
		font-weight: 300;
		margin-bottom: 20px;
	}

	h3 {
		color: ${props => props.theme.colors.textColor};
		font-size: 0.8rem;
		opacity: 0.5;
		font-weight: 400;
		margin: 12px 0 8px 0;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	h3:first-of-type {
		margin-top: 0;
	}
`;

const LegendList = styled.ul`
	padding: 0;
	list-style: none;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const LegendItem = styled.li`
	display: grid;
	grid-template-columns: 20px 1fr;
	gap: 10px;
	align-items: center;
	color: ${props => props.theme.colors.textColor};
	text-transform: capitalize;
`;

const ColorLine = styled.div`
	border-top: 3px ${props => (props.$dashed ? 'dashed' : 'solid')} ${props => props.color};
	width: 100%;
`;

const MapLegend = () => {
	const { pickedModelClasses, annotationClasses, colorScheme } = useProject();

	const hasDetections = pickedModelClasses?.length > 0;
	const hasAnnotations = annotationClasses?.length > 0;

	if (!hasDetections && !hasAnnotations) return null;


	return (
		<Legend>
			<h2>Model Classes</h2>

			
			{hasDetections && (
				<>
					<h3>Detections</h3>
					<LegendList>
						{pickedModelClasses.map(legendItem => {
							const color = convertToRgba(colorScheme[legendItem.id]?.color);
							if (!color) return null;
							return (
								<LegendItem key={`det-${legendItem.id}`}>
									<ColorLine color={color} />
									<div>{legendItem.label}</div>
								</LegendItem>
							);
						})}
					</LegendList>
				</>
				
			)}

			{hasAnnotations && (
				<>
					<h3>Training Data</h3>
					<LegendList>
						{annotationClasses.map(legendItem => {
							const color = convertToRgba(colorScheme[legendItem.id]?.color) || 'rgba(255, 165, 0, 1)';
							return (
								<LegendItem key={`ann-${legendItem.id}`}>
									<ColorLine color={color} $dashed />
									<div>{legendItem.label}</div>
								</LegendItem>
							);
						})}
					</LegendList>
					</>
			)}
		</Legend>
		
	);
};

export default MapLegend;
